import { BASE_URL } from "../constants";
import { getAuthToken } from "../utils";

function buildAuthHeaders(token, extraHeaders = {}) {
  const resolvedToken = token || getAuthToken();
  return {
    ...extraHeaders,
    ...(resolvedToken ? { Authorization: `Token ${resolvedToken}` } : {}),
  };
}

export async function fetchDashboardVersion() {
  try {
    const response = await fetch(`${BASE_URL}insurance/dashboard-version/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching dependency:", error);
    throw error;
  }
}

export async function fetchDashboardUpdatePayload(version) {
  try {
    const qs = version ? `?version=${encodeURIComponent(version)}` : "";
    const response = await fetch(`${BASE_URL}insurance/dashboard-update/${qs}`, {
      method: "GET",
      headers: buildAuthHeaders(undefined, {
        "Content-Type": "application/json",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching dashboard update payload:", error);
    throw error;
  }
}

export async function createOrEditUpdate({ id, name, version, title, subtitle, header, items, images, replaceImages, imageOrder } = {}, token) {
  try {
    const form = new FormData();
    if (id) form.append('id', String(id));
    if (name) form.append('name', name);
    if (version) form.append('version', version);
    if (title) form.append('title', title);
    if (subtitle) form.append('subtitle', subtitle);
    if (header) form.append('header', header);
    if (items) form.append('items', typeof items === 'string' ? items : JSON.stringify(items));
    if (replaceImages !== undefined) form.append('replace_images', String(Boolean(replaceImages)));
    if (imageOrder) form.append('image_order', typeof imageOrder === 'string' ? imageOrder : JSON.stringify(imageOrder));

    if (images && images.length) {
      Array.from(images).forEach((f) => form.append('images', f));
    }

    const headers = buildAuthHeaders(token);

    const response = await fetch(`${BASE_URL}insurance/updates/`, {
      method: 'POST',
      headers,
      body: form,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP error! status: ${response.status} ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating/editing update:', error);
    throw error;
  }
}

export async function fetchUpdatesList(token) {
  try {
    const headers = buildAuthHeaders(token, { "Content-Type": "application/json" });

    const response = await fetch(`${BASE_URL}insurance/updates-list/`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching updates list:", error);
    throw error;
  }
}

export async function publishUpdate({ id, version } = {}, token) {
  try {
    const headers = buildAuthHeaders(token, { "Content-Type": "application/json" });

    const response = await fetch(`${BASE_URL}insurance/updates-publish/`, {
      method: "POST",
      headers,
      body: JSON.stringify({ id, version }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP error! status: ${response.status} ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error publishing update:", error);
    throw error;
  }
}

export async function uploadUpdateImages(updateId, files, token) {
  try {
    if (!updateId) throw new Error('updateId required');
    const form = new FormData();
    Array.from(files).forEach((f) => form.append('images', f));

    const headers = buildAuthHeaders(token);

    const response = await fetch(`${BASE_URL}insurance/updates/${updateId}/images/`, {
      method: 'POST',
      headers,
      body: form,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP error! status: ${response.status} ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error uploading update images:', error);
    throw error;
  }
}
